/* ClientError.ts */

/* Axios */
import { HttpStatusCode } from "axios";

/* Constants */
import { GlobalMessageType } from "src/shared/constants/common/GlobalMessage";
import { ErrorMessage } from "src/shared/constants/common/ErrorMessage";
import { ClientErrorProps } from "src/shared/interfaces/common/GlobalMessage";

export class ClientError extends Error {
  public type: GlobalMessageType;
  public statusCode: HttpStatusCode;

  constructor({
    message,
    type,
    statusCode,
  }: ClientErrorProps) {
    super(message);
    this.type = type;
    this.statusCode = statusCode;
  }

  static noContent(): ClientError {
    return new ClientError({
      type: GlobalMessageType.WARNING,
      statusCode: HttpStatusCode.NoContent,
      message: ErrorMessage.NO_CONTENT,
    });
  }

  static unexpected(): ClientError {
    return new ClientError({
      type: GlobalMessageType.ERROR,
      statusCode: HttpStatusCode.BadRequest,
      message: ErrorMessage.UNEXPECTED_ERROR,
    });
  }

  static invalidCredentials(): ClientError {
    return new ClientError({
      type: GlobalMessageType.ERROR,
      statusCode: HttpStatusCode.Unauthorized,
      message: ErrorMessage.INVALID_CREDENTIALS,
    });
  }

  static internal(): ClientError {
    return new ClientError({
      type: GlobalMessageType.ERROR,
      statusCode: HttpStatusCode.InternalServerError,
      message: ErrorMessage.INTERNAL_SERVER_ERROR,
    });
  }

  static forbidden(message: string = ErrorMessage.UNEXPECTED_ERROR): ClientError {
    return new ClientError({
      type: GlobalMessageType.ERROR,
      statusCode: HttpStatusCode.Forbidden,
      message,
    });
  }
}
